var _circle, _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoblog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.227 134.378V278H291.997V134.378C291.997 131.095 290.722 127.947 288.451 125.625C286.18 123.304 283.101 122 279.889 122H133.254C130.054 122.015 126.991 123.326 124.737 125.646C122.482 127.967 121.219 131.107 121.227 134.378Z",
    fill: "#C8C8C8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.227 200L130.381 147.25H279.809V177.33",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.072 174.064L121.227 278H291.997V177.357H214.438L199.404 163.827H116.877C115.616 163.828 114.369 164.104 113.22 164.636C112.071 165.168 111.046 165.944 110.213 166.912C109.38 167.881 108.758 169.019 108.389 170.252C108.02 171.486 107.912 172.785 108.072 174.064Z",
    fill: "#DEDEDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.087 234.438H206.215V230.374H200.119V220.214H196.055V232.406L198.087 234.438Z",
    fill: "#F1F1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.957 212.773C186.867 214.556 184.301 217.122 182.517 220.212C180.734 223.302 179.795 226.807 179.797 230.375C179.795 233.942 180.734 237.447 182.517 240.537C184.301 243.627 186.867 246.193 189.957 247.976V256.791L191.989 258.823H208.245L210.277 256.791V247.976C213.367 246.193 215.933 243.627 217.717 240.537C219.5 237.447 220.439 233.942 220.437 230.375C220.439 226.807 219.5 223.302 217.717 220.212C215.933 217.122 213.367 214.556 210.277 212.773V203.958L208.245 201.926H191.989L189.957 203.958V212.773ZM216.373 230.375C216.373 234.686 214.661 238.821 211.612 241.869C208.563 244.918 204.428 246.631 200.117 246.631C195.806 246.631 191.671 244.918 188.622 241.869C185.574 238.821 183.861 234.686 183.861 230.375C183.861 226.063 185.574 221.928 188.622 218.88C191.671 215.831 195.806 214.118 200.117 214.118C204.428 214.118 208.563 215.831 211.612 218.88C214.661 221.928 216.373 226.063 216.373 230.375Z",
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoblog);
export default __webpack_public_path__ + "static/media/noblog.8c3216c49cf59a7ffde67c0b27139f12.svg";
export { ForwardRef as ReactComponent };